import React from 'react';

interface ResumoSelecaoProps {
  selecionadas: number;
  total: number;
  totalFiltrados: number;
  totalPotenciaMw: number;
}

function formatarInt(valor: number): string {
  return valor.toLocaleString('pt-BR');
}

function formatarMw(valor: number): string {
  return valor.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

/**
 * Footer estatistico do modal — fonte unica de contadores.
 *
 * FE-LAYOUT-007 #3: antes existiam dois lugares mostrando informacao
 * correlata — "X resultados" no topo (dentro do ChipsFiltrosAtivos) e
 * "X selecionadas" no rodape. Foi unificado aqui:
 *   - filtro ativo (totalFiltrados < total): "N resultados · X selecionadas · Y MW"
 *   - sem filtro:                            "X de N selecionadas · Y MW"
 *
 * Single source of truth por metrica (IA principle).
 */
export default function ResumoSelecao({
  selecionadas,
  total,
  totalFiltrados,
  totalPotenciaMw,
}: ResumoSelecaoProps) {
  const filtroAtivo = totalFiltrados < total;
  return (
    <div className="windx-seletor-usinas__resumo" aria-live="polite">
      {filtroAtivo ? (
        <>
          <span className="windx-seletor-usinas__resumo-resultados">
            {formatarInt(totalFiltrados)}
            {totalFiltrados === 1 ? ' resultado' : ' resultados'}
          </span>
          <span aria-hidden="true">{' · '}</span>
          <strong className="windx-seletor-usinas__resumo-contador">
            {formatarInt(selecionadas)}
            {selecionadas === 1 ? ' selecionada' : ' selecionadas'}
          </strong>
        </>
      ) : (
        <strong className="windx-seletor-usinas__resumo-contador">
          {formatarInt(selecionadas)}
          {' de '}
          {formatarInt(total)}
          {' selecionadas'}
        </strong>
      )}
      <span className="windx-seletor-usinas__resumo-mw">
        {' · '}
        {formatarMw(totalPotenciaMw)}
        {' MW'}
      </span>
    </div>
  );
}
